import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ListsResponse } from '@/api';

export interface ComplianceListsSliceState {
  data: ListsResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: ComplianceListsSliceState = {
  data: null,
  loading: false,
  error: null,
};

const complianceListsSlice = createSlice({
  name: 'complianceLists',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<ListsResponse | null>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    fetchLists: (state) => ({
      ...state,
      error: null,
      loading: true,
    }),
  },
});

export { complianceListsSlice };
